import 'reflect-metadata';
import Vue from 'vue';

import './assets/styles/main.scss';

import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import { Integrations } from '@sentry/tracing';

import VModal from 'vue-js-modal';
import PortalVue from 'portal-vue';

import store from './store';
import App from './App.vue';
import router from './router';
import i18n from './i18n';
import './plugins/element';
import './validations';

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://d69fd978d0a249d9bd6906566732834d@o443331.ingest.sentry.io/5416880',
    integrations: [
      new VueIntegration({
        Vue,
        tracing: true,
      }),
      new Integrations.BrowserTracing(),
    ],
    tracesSampleRate: 1,
  });
}

Vue.config.productionTip = false;

Vue.use(VModal);
Vue.use(PortalVue);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
